import { Caption, Heading } from "@shopify/polaris"
import React, { useContext } from "react"
import { Trans, useTranslation } from "react-i18next"
import { Video } from "../Video.jsx"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"

export const Step1 = ({ randomAppNameButton }) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()

	const KopyOnboardingVideo1 =
		"https://kopy.b-cdn.net/kopy-onboarding-1-new.webm"

	const openShopifyAdminPage = () => {
		try {
			const store = state.shop.split(".myshopify.com")?.[0] || null

			if (!store) return

			const adminPageUrl = new URL(
				`https://admin.shopify.com/store/${store}/settings/apps/development`,
			)
			window.open(adminPageUrl, "_blank")
		} catch (error) {
			console.error(error)
		}
	}

	const adminButton = (
		<span
			style={{
				display: "inline-flex",
				gap: "0.2rem",
				alignItems: "center",
				padding: "0.1rem 0.4rem",
				background: "#fff",
				borderRadius: "1rem",
				border: "1px solid #ccc",
				boxShadow:
					"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
				cursor: "pointer",
			}}
			onClick={openShopifyAdminPage}
		>
			<span>Shopify Admin: App Development</span>
			<svg
				style={{ height: "1rem", width: "1rem", color: "#222" }}
				viewBox="0 0 16 16"
			>
				<g fill="currentColor">
					<path d="M6.22 8.72a.75.75 0 0 0 1.06 1.06l5.22-5.22v1.69a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0 0 1.5h1.69z"></path>
					<path d="M3.5 6.75c0-.69.56-1.25 1.25-1.25H7A.75.75 0 0 0 7 4H4.75A2.75 2.75 0 0 0 2 6.75v4.5A2.75 2.75 0 0 0 4.75 14h4.5A2.75 2.75 0 0 0 12 11.25V9a.75.75 0 0 0-1.5 0v2.25c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25z"></path>
				</g>
			</svg>
		</span>
	)

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "0.5rem",
				paddingBottom: "0.5rem",
			}}
		>
			<div style={{ width: "100%", height: "auto" }}>
				<Video videoSrc={KopyOnboardingVideo1} />
			</div>

			<h1
				style={{
					marginTop: "1rem",
					marginBottom: "1rem",
					fontSize: "1.2rem",
					fontWeight: "600",
					color: "#222",
					lineHeight: "1.1",
				}}
			>
				{t("link_store.step_1")}
			</h1>

			<p
				style={{
					marginBottom: "0.5rem",
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.3",
				}}
			>
				<Trans
					i18nKey="link_store.step_1_1"
					components={{ b: <b></b>, adminButton }}
				></Trans>
			</p>
			<p
				style={{
					marginBottom: "0.5rem",
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.1",
				}}
			>
				<Trans
					i18nKey="link_store.step_1_2"
					components={{ b: <b></b> }}
				></Trans>
			</p>
			<p
				style={{
					marginBottom: "0.5rem",
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.1",
				}}
			>
				<Trans
					i18nKey="link_store.step_1_3"
					components={{ b: <b></b> }}
				></Trans>
			</p>
			<p
				style={{
					fontSize: "0.85rem",
					fontWeight: "400",
					color: "#333",
					lineHeight: "1.1",
				}}
			>
				<Trans
					i18nKey="link_store.step_1_4"
					components={{ b: <b></b>, randomAppNameButton }}
				></Trans>
			</p>
		</div>
	)
}
